<template>

  <button v-if="!hidden" @click="routeToPage" :class="isChild ? 'bottom-18' : 'bottom-8'" class="fixed z-50 right-4  hover:bg-nova-accent  flex items-center gap-0.5 h-14 w-14  justify-center flex-col rounded-full shadow-lg bg-draksy/70 backdrop-blur-md text-white hover:text-white text-xs font-medium  transition">
    <EditPencil class="w-4 h-4"/>
    <span>Edit</span>
  </button>
</template>
<script setup>
import {EditPencil} from "@iconoir/vue";
import router from "@/router/index.js";


import { useRoute } from 'vue-router';
import {computed, onMounted, ref} from "vue";
import {previewSetupMode, studioMode} from "@/classes/previewBridge.js";

const route = useRoute();
// Set after mount so the server render and hydration agree.
const framed = ref(false);
onMounted(() => { framed.value = window.self !== window.top; });

const props = defineProps({
  productId: {
    type: String,
    required: false,
  }
})

const hidden = computed(() => {
  // Tokyo's website setup shows its own Setup menu instead.
  // ...and so does the Website Studio, in setup or edit mode.
  if (previewSetupMode.value || studioMode.value !== 'off') {
    return true
  }
  // ...and inside the studio's clean Preview (framed, mode off), where Edit would leave the studio.
  if (framed.value) {
    return true
  }
  const pathSegments = route.path.split('/').filter(Boolean);
  const lastTwo = pathSegments.slice(-2);
  if (lastTwo.length > 0 && (lastTwo[0] === 'post' || lastTwo[0] === 'showcase' || lastTwo[0] === 'products')) {
    return true
  }
  return false
})

const routeMap = {
  '/': '/web-site-editor/home-page',
  '/about': '/web-site-editor/about',
  '/contact': '/web-site-editor/contact-page',
  '/products': '/products',
}

const isChild = computed(() => {
  return window && window.self !== window.top;
})

const routeToPage = () => {
  const mapped = routeMap[route.path];

  const pathSegments = route.path.split('/').filter(Boolean);
  const lastTwo = pathSegments.slice(-2);
  const fallbackPath = `/web-site-editor/page/${lastTwo.join('/')}`;

  let targetPath;

  if (lastTwo.length > 1 && lastTwo[0] === 'products') {
    targetPath = '/products/' + props.productId;
  }
  else {
    targetPath = mapped || fallbackPath;
  }

  const isInIframe = window.self !== window.top;

  if (isInIframe) {
    window.parent.postMessage({ type: 'navigate', path: targetPath }, '*');
  } else {
    window.location.href = targetPath;
  }
};


</script>


<style scoped>

</style>